if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.addEventListener('click', (event) => {
          const button = event.target.closest('[data-lb-media-step]');
          if (button) this.stepMedia24(Number(button.dataset.lbMediaStep));
        });
        this.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault(); this.stepMedia24(event.key === 'ArrowRight' ? 1 : -1);
          }
        });
      }

      stepMedia24(step) {
        const media = [...this.querySelectorAll('.product-media-modal__content > [data-media-id]')].filter(e => getComputedStyle(e).display !== 'none');
        if (!media.length) return;
        const content = this.querySelector('[role="document"]');
        const center = content.getBoundingClientRect().top + content.clientHeight / 2;
        const current = media.reduce((best, item, index) => Math.abs(item.getBoundingClientRect().top + item.clientHeight / 2 - center) < best.distance ? {index, distance: Math.abs(item.getBoundingClientRect().top + item.clientHeight / 2 - center)} : best, {index:0,distance:Infinity}).index;
        const next = media[(current + step + media.length) % media.length];
        media.forEach(item => item.classList.toggle('active', item === next));
        next.scrollIntoView({block:'center',behavior:'auto'});
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        if (!activeMedia) return;
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView({block:'center',behavior:'auto'});

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
